module.exports = __webpack_public_path__ + "static/media/54_A.f1a536c9.png";